export const SET_USUARIOS = 'usuarios/SET_USUARIOS';

export const setUsuarios = usuarios => {
  return {
    type: SET_USUARIOS,
    payload: usuarios
  };
};
